import type { CustomProduct } from "@apptus/esales-api";

const EXPLODED_VARIANT_KEY = "exploded-variant";

export default function isVariantExploded(product: CustomProduct) {
  if (!product.custom) return false;
  const { variantFlags = [], productFlags = [] } = product.custom;
  const flags = [...variantFlags, ...productFlags].flatMap((flag) => flag.id);
  return flags.some((flag) => flag === EXPLODED_VARIANT_KEY);
}
